// The web twin of leazepro_app's route_constants.dart; nothing hardcodes a path string.
export const routes = {
  login: '/login',
  verify: '/verify',
  /** A refer & earn link lands here (LP-998): keeps `?ref=`, then the login. */
  signup: '/signup',
  /** The landing's offer links (LP-1043): `/plans?promo=<code>` opens the plans page with the code (LP-1005). */
  plans: '/plans',
  completeProfile: '/complete-profile',
  emailVerified: '/email-verified',
  /** Paddle's default payment link (LP-514): opens `?_ptxn=` checkouts. Public. */
  pay: '/pay',

  landlord: {
    root: '/landlord',
    dashboard: '/landlord/dashboard',
    properties: '/landlord/properties',
    propertyNew: '/landlord/properties/new',
    propertyInterests: '/landlord/properties/interests',
    property: (id: string) => `/landlord/properties/${id}`,
    propertyEdit: (id: string) => `/landlord/properties/${id}/edit`,
    leases: '/landlord/leases',
    leaseNew: '/landlord/leases/new',
    leaseHistory: '/landlord/leases/history',
    tenants: '/landlord/tenants',
    transactions: '/landlord/transactions',
    paymentNew: '/landlord/transactions/new',
    subscriptions: '/landlord/subscriptions',
    maintenance: '/landlord/maintenance',
  },

  tenant: {
    root: '/tenant',
    dashboard: '/tenant/dashboard',
    transactions: '/tenant/transactions',
    browse: '/tenant/browse',
    browseDetail: (id: string) => `/tenant/browse/${id}`,
    leaseHistory: '/tenant/leases/history',
    interests: '/tenant/interests',
    profile: '/tenant/profile',
  },

  lease: (id: string) => `/lease/${id}`,
  leaseAgreement: (leaseId: string) => `/lease/${leaseId}/agreement`,
  leasePay: (leaseId: string) => `/lease/${leaseId}/pay`,
  notifications: '/notifications',
  account: '/account',
  accountEdit: '/account/edit',
  accountNotifications: '/account/notifications',
  accountPreferences: '/account/preferences',
  accountSessions: '/account/sessions',
  accountRefer: '/account/refer',
  support: '/account/support',
  supportRequest: (id: string) => `/account/support/${encodeURIComponent(id)}`,
  kyc: '/account/kyc',
  kycBank: '/account/kyc?type=bank',

  forbidden: '/403',
  gallery: '/gallery',
} as const
